import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

interface FlexibleToggleCellComponentInterface {
	Element: HTMLDivElement;
	Args: {
		showAll: boolean;
		toggleShowAll: () => void;
	};
}

const FlexibleToggleCellComponent: TOC<FlexibleToggleCellComponentInterface> = <template>
	<td class="toggle">
		<a role="button" {{on "click" @toggleShowAll}}>
			Show
			{{#if @showAll}}less{{else}}more{{/if}}
		</a>
	</td>
</template>;

export default FlexibleToggleCellComponent;
